import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, forwardRef, useRef } from "react";
import ErrorTooltip from "../../others/error-tooltip/index.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import RadioButton from "./components/radio-button/index.js";
import * as S from "./styled.js";
export const RadioButtonGroup = /*#__PURE__*/ forwardRef(({ options , onChange , disabled =false , className , variant ='horizontal' , radioVariant , error , hasError , ...rest }, ref)=>{
    const wrapperRef = useRef(null);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(S.RadioButtonWrapper, {
                ref: wrapperRef,
                "data-testid": "RadioButtonGroup",
                className: className,
                $variant: variant,
                ...rest,
                children: Children.toArray(options.map((radio)=>/*#__PURE__*/ _jsx(RadioButton, {
                        label: radio.label,
                        name: radio.name,
                        value: radio.value,
                        checked: typeof rest.value === 'undefined' ? radio.checked : String(rest.value) === String(radio.value),
                        onChange: onChange,
                        count: radio.count,
                        rightContent: radio.rightContent,
                        disabled: disabled,
                        variant: radioVariant,
                        hasError: hasError,
                        ref: ref,
                        extended: options.length <= 2
                    })))
            }),
            /*#__PURE__*/ _jsx(ErrorTooltip, {
                referenceElement: wrapperRef.current,
                error: error,
                isVisible: !!hasError
            })
        ]
    });
});
RadioButtonGroup.displayName = 'RadioButtonGroup';
export const FormRadioButtonGroup = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const { field , error , hasError  } = useInput(props);
    return /*#__PURE__*/ _jsx(RadioButtonGroup, {
        ...rest,
        ...field,
        error: error,
        hasError: hasError
    });
};
export default RadioButtonGroup;

//# sourceMappingURL=index.js.map